export default["__VITE_ASSET__wYpLJ8c5__","__VITE_ASSET__YNya93gX__"];